import Breadcrumb from "components/Common/Breadcrumb2"
import toast from "components/Toast/Toast"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { withTranslation } from "react-i18next"
import Select from "react-select"
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import { getAllShippingCompanies } from "services/shipping-companies/calls"
import {
  addQueue,
  deleteQueue,
  getAllQueues,
  getQueue,
  patchQueue,
  restoreQueue,
} from "services/support/calls"
import { getRoles } from "services/users/calls"

const limit = 20

const initPageOptions = {
  sizePerPage: limit,
  totalSize: 0,
  custom: true,
  showTotal: true,
  hideSizePerPage: true,
  hidePageListOnlyOnePage: true,
  prePageText: "Anterior",
  nextPageText: "Próximo",
  paginationTotalRenderer: () => {
    return (
      <div className="d-inline">
        <span className="react-bootstrap-table-pagination-total">
          Registros Retornados: {total}
        </span>
      </div>
    )
  },
}

const FilaAtendimento = props => {
  document.title = "Cadastro de Filas de Atendimento | Sensetek"
  moment.locale("pt-br")
  const { t } = props

  // Nova Fila
  const nameRef = useRef()
  const [newRolesFila, setNewRolesFila] = useState([])
  const [newIsCourrier, setNewIsCourrier] = useState(false)
  const [newTransportadora, setNewTransportadora] = useState([])

  // Alterar Fila
  const [alterIsCourrier, setAlterIsCourrier] = useState(false)
  const [alterTransportadora, setAlterTransportadora] = useState({})

  const novoName2Ref = useRef()
  const [isLoading, setIsLoading] = useState(true)
  const [filas, setFilas] = useState([])
  const [confirm, setConfirm] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [modalAlterar, setModalAlterar] = useState(false)
  const [roles, setRoles] = useState([])
  const [transportadoras, setTransportadoras] = useState([])
  const [placeholderName, setPlaceholderName] = useState("")

  const [rolesFila, setRolesFila] = useState([])
  const [queue, setQueue] = useState([])

  const defaultSorted = [
    {
      dataField: "accountId",
      order: "asc",
    },
  ]

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const fetchQueues = async () => {
    try {
      const queues = await getAllQueues()
      setFilas(queues)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const rolesOptions = roles.map(role => ({ value: role.id, label: role.name }))
  // const courierOptions = listTransportadoras.map(courier => ({
  //   value: courier.id,
  //   label: courier.name,
  // }))
  const courierOptions = transportadoras.map(t => ({
    value: t.id,
    label: t.name,
  }))

  useEffect(() => {
    const fetchRoles = async () => {
      const { payload } = await getRoles()
      const { roles } = payload
      setRoles(roles)
    }
    const fecthCourriers = async () => {
      try {
        const { payload } = await getAllShippingCompanies()
        const { companies } = payload
        setTransportadoras(companies)
      } catch (error) {
        console.error(error)
      }
    }
    try {
      setIsLoading(true)
      fetchRoles()
      fecthCourriers()
      fetchQueues()
    } catch (error) {
      console.log(error)
    }
  }, [])

  const handleSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      if (nameRef.current.value) {
        if (newIsCourrier) {
          await addQueue(
            nameRef.current.value,
            newRolesFila,
            newTransportadora.value
          )
        } else {
          await addQueue(nameRef.current.value, newRolesFila)
        }
        fetchQueues()
        toast("success", "Fila adicionada com sucesso!")
      } else {
        toast("warning", "Não é possível adicionar fila com nome vazio.")
        nameRef.current.focus()
      }
      setNewRolesFila([])
      setNewIsCourrier(false)
      setNewTransportadora([])
    } catch (error) {
      toast("warning", "Falha ao criar fila.")
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: false,
      headerStyle: {
        width: "50px",
      },
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "name",
      text: "Nome",
      sort: false,
    },
    {
      dataField: "status",
      isDummyField: true,
      text: "Situação",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "10%", textAlign: "center" }
      },
      formatter: (cellContent, row) =>
        row.deletedAt ? (
          <Badge color="warning" className="me-1">
            <b>Inativo</b>
          </Badge>
        ) : (
          <Badge color="primary" className="me-1">
            <b>Ativo</b>
          </Badge>
        ),
    },
    {
      dataField: "createdAt",
      text: "Criação",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => (
        <b>{moment(cellContent, "YYYY-MM-DD").format("DD/MM/YYYY")}</b>
      ),
    },
    {
      dataField: "updatedAt",
      text: "Atualização",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => (
        <b>
          {row.updatedAt
            ? moment(cellContent, "YYYY-MM-DD").format("DD/MM/YYYY")
            : "-"}
        </b>
      ),
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "Ações",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "10%", textAlign: "center" }
      },
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-primary`}
              onClick={async () => {
                setIsLoading(true)
                try {
                  const queue = await getQueue(row.id)
                  setRolesFila(
                    queue?.roles.map(role => ({
                      value: role.id,
                      label: role.name,
                    }))
                  )
                  setQueue(queue)
                  setAlterTransportadora(
                    queue?.shippingCompanyId
                      ? {
                          value: queue?.shippingCompanyId,
                          label: transportadoras.find(
                            t => t.id === queue?.shippingCompanyId
                          ).name,
                        }
                      : []
                  )
                  setAlterIsCourrier(queue?.shippingCompanyId ? true : false)
                  setPlaceholderName(queue.name)
                } catch (error) {
                  console.log(error)
                } finally {
                  setIsLoading(false)
                  setModalAlterar(true)
                }
              }}
            >
              <i
                className="mdi mdi-account-edit"
                id={`altToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`altToolTip${row.id}`}>
              Alterar
            </UncontrolledTooltip>
          </li>
          {!row?.isAuto && (
            <li>
              <a
                target="_blank"
                className={`btn btn-sm btn-${
                  row.deletedAt ? "secondary" : "danger"
                }`}
                onClick={async () => {
                  if (row.deletedAt) {
                    try {
                      setIsLoading(true)
                      await restoreQueue(row.id)
                      fetchQueues()
                      toast("success", "Fila ativada com sucesso!")
                    } catch (error) {
                      toast("warning", "Falha ao ativar fila.")
                      console.log(error)
                    } finally {
                      setIsLoading(false)
                    }
                  } else {
                    setConfirm({
                      title: "Confirmação",
                      body: (
                        <div>
                          <p>Esta ação ira desabilitar esta opção de fila.</p>
                          <p>
                            Por favor, confirme se tem certeza que deseja
                            desabilitar esta fila de atendimento?
                          </p>
                        </div>
                      ),
                      onConfirm: async () => {
                        setIsLoading(true)
                        try {
                          await deleteQueue(row.id)
                          fetchQueues()
                          toast("success", "Fila apagada com sucesso!")
                        } catch (error) {
                          toast("warning", "Falha ao apagar fila.")
                          console.log(error)
                        } finally {
                          setIsLoading(false)
                        }
                      },
                    })
                    setShowConfirm(true)
                  }
                }}
              >
                <i
                  className={`mdi mdi-${
                    row.deletedAt ? "account-reactivate" : "delete-forever"
                  }`}
                  id={`delToolTip${row.id}`}
                ></i>
              </a>
              <UncontrolledTooltip
                placement="top"
                target={`delToolTip${row.id}`}
              >
                {`${row.deletedAt ? "Reativar" : "Desativar"}`}
              </UncontrolledTooltip>
            </li>
          )}
        </ul>
      ),
    },
  ]

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[
              { title: props.t("Fila de Atendimento"), path: "#" },
            ]}
          />
          <Row>
            <Col>
              <Card className="mb-0 border-bottom">
                <CardHeader tag={"h5"} className="bg-transparent border-bottom">
                  {t("Adicionar")}
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col sm={8}>
                        <FormGroup>
                          <br></br>
                          <Label>{t("Nome da Fila")}</Label>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Fila de Atendimento"
                            ref={nameRef}
                            disabled={isLoading}
                            onChange={e => {
                              nameRef.current.value = e.target.value
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={4}>
                        <br></br>
                        <FormGroup>
                          <Label>{t("Perfis")}</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            isMulti
                            options={rolesOptions}
                            placeholder="Perfis"
                            value={newRolesFila}
                            onChange={e => {
                              setNewRolesFila(e)
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={2}>
                        <FormGroup check>
                          <Input
                            type="checkbox"
                            checked={newIsCourrier}
                            onChange={e => {
                              setNewIsCourrier(e.target.checked)
                            }}
                          />{" "}
                          <Label check>Transportadora?</Label>
                        </FormGroup>
                      </Col>
                      <Col sm={4}>
                        <FormGroup>
                          <Label>{t("Transportadora")}</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            isDisabled={!newIsCourrier}
                            options={courierOptions}
                            placeholder="Transportadora"
                            value={newTransportadora}
                            onChange={e => {
                              setNewTransportadora(e)
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="d-flex align-items-end">
                        <FormGroup>
                          <Button type="submit">{t("Adicionar")}</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h5"} className="bg-transparent border-bottom">
                  Lista de Filas
                </CardHeader>
                <CardBody>
                  {!isLoading &&
                    (filas.length > 0 ? (
                      <PaginationProvider
                        pagination={paginationFactory(initPageOptions)}
                        keyField="id"
                        columns={columns}
                        data={filas}
                      >
                        {({ paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="id"
                            columns={columns}
                            columnToggle
                            data={filas}
                            search
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row>
                                  <Col xl="12">
                                    <BootstrapTable
                                      keyField={"id"}
                                      bordered={true}
                                      striped={true}
                                      condensed
                                      defaultSorted={defaultSorted}
                                      selectRow={selectRow}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <h5>Nenhum dado foi encontrado.</h5>
                      </div>
                    ))}
                  {isLoading && (
                    <div
                      className="accordion-body"
                      style={{ textAlign: "center" }}
                    >
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={async () => {
              await confirm?.onConfirm()
              setShowConfirm(false)
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={modalAlterar}
        toggle={() => {
          setModalAlterar(!modalAlterar)
        }}
        centered
      >
        <ModalHeader>
          Confirmação
          <button
            type="button"
            onClick={() => {
              setModalAlterar(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Label>{t("Novo Nome")}</Label>
              <Input
                type="text"
                className="form-control"
                defaultValue={placeholderName}
                ref={novoName2Ref}
                disabled={isLoading}
                readOnly={queue?.isAuto}
                onChange={e => {
                  novoName2Ref.current.value = e.target.value
                }}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <Label>{t("Perfis")}</Label>
              <Select
                classNamePrefix="reactSelect"
                isMulti
                options={rolesOptions}
                placeholder="Perfis"
                value={rolesFila}
                onChange={e => {
                  setRolesFila(e)
                }}
              />
            </Col>
          </Row>
          <br></br>
          <Row>
            <Col sm={4}>
              <FormGroup check>
                <Input
                  type="checkbox"
                  checked={alterIsCourrier}
                  onChange={e => {
                    setAlterIsCourrier(e.target.checked)
                  }}
                />{" "}
                <Label check>Transportadora?</Label>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label>{t("Transportadora")}</Label>
                <Select
                  classNamePrefix="reactSelect"
                  isDisabled={!alterIsCourrier}
                  options={courierOptions}
                  placeholder="Transportadora"
                  value={alterTransportadora}
                  onChange={e => {
                    setAlterTransportadora(e)
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              setModalAlterar(false)
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={async () => {
              const novoNome = novoName2Ref.current.value || placeholderName
              try {
                setIsLoading(true)
                if (alterIsCourrier) {
                  await patchQueue(
                    queue.id,
                    novoNome,
                    rolesFila,
                    alterTransportadora.value
                  )
                } else {
                  await patchQueue(queue.id, novoNome, rolesFila)
                }
                fetchQueues()
                toast("success", "Fila alterada com sucesso!")
              } catch (error) {
                toast("warning", "Falha ao alterar fila.")
                console.log(error)
              } finally {
                setIsLoading(false)
              }
              setModalAlterar(false)
            }}
          >
            Confirmar
          </button>
        </ModalFooter>
      </Modal>
    </>
  )
}

FilaAtendimento.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(FilaAtendimento)
